import { EntityType } from '@frontend/common';
import { ObjectBadge } from '@frontend/components/badge';
import React from 'react';

import AsyncComponent from '../async-component';

interface Props {
    id: string;
    type: string;
    className?: string;
    disableClick?: boolean;
    clearable?: {
        onClear: () => void;
    };
    queryParamNavigation?: boolean;
}

const fallback = (
    <span className='placeholder-glow'>
        <span className='placeholder'>loading</span>
    </span>
);
export const ObjectBadgeMapper = (props: Props) => {
    switch (props.type) {
        case 'account_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.ACCOUNT}
                    />
                </AsyncComponent>
            );
        case 'branding_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.BRANDING}
                    />
                </AsyncComponent>
            );
        case 'colli_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.COLLI}
                    />
                </AsyncComponent>
            );
        case 'functionality_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.FUNCTIONALITY}
                    />
                </AsyncComponent>
            );
        case 'schedule_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.SCHEDULE}
                    />
                </AsyncComponent>
            );
        case 'spot_id':
        case 'default_spot_id':
        case 'current_spot_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.SPOT}
                    />
                </AsyncComponent>
            );
        case 'product_id':
        case 'kit_id':
        case 'products':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PRODUCT}
                    />
                </AsyncComponent>
            );
        case 'user_id':
        case 'cc_user_id':
        case 'drop_off_user_id':
        case 'pick_up_user_id':
        case 'withdraw_user_id':
        case 'return_user_id':
        case 'backup_notification_user_id':
        case 'supervisor_user_id':
        case 'owner_id':
        case 'sender_id':
        case 'receiver_id':
        case 'users':
        case 'senders':
        case 'receivers':
        case 'owners':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.USER}
                    />
                </AsyncComponent>
            );
        case 'cost_center_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.COST_CENTER}
                    />
                </AsyncComponent>
            );
        case 'budget_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.BUDGET}
                    />
                </AsyncComponent>
            );
        case 'certificate_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.CERTIFICATE}
                    />
                </AsyncComponent>
            );
        case 'equipment_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.EQUIPMENT}
                    />
                </AsyncComponent>
            );
        case 'default_playlist_id':
        case 'playlist_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PLAYLIST}
                    />
                </AsyncComponent>
            );
        case 'playlist_item_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PLAYLIST_ITEM}
                    />
                </AsyncComponent>
            );
        case 'module_id':
        case 'current_module_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.MODULE}
                    />
                </AsyncComponent>
            );
        case 'module_template_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.MODULE_TEMPLATE}
                    />
                </AsyncComponent>
            );
        case 'slot_id':
        case 'current_slot_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.SLOT}
                    />
                </AsyncComponent>
            );
        case 'template_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.LABEL_TEMPLATE}
                    />
                </AsyncComponent>
            );
        case 'content_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.LABEL_TEMPLATE_CONTENT}
                    />
                </AsyncComponent>
            );
        case 'notification_template_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.NOTIFICATION_TEMPLATE}
                    />
                </AsyncComponent>
            );
        case 'notification_content_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.NOTIFICATION_CONTENT}
                    />
                </AsyncComponent>
            );
        case 'slot_template_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.SLOT_TEMPLATE}
                    />
                </AsyncComponent>
            );
        case 'attribute_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.ATTRIBUTE}
                    />
                </AsyncComponent>
            );
        case 'group_id':
        case 'user_group_id':
        case 'access_control_user_group_id':
        case 'default_user_group_id':
        case 'open_drop_off_senders_user_group_id':
        case 'open_drop_off_receivers_user_group_id':
        case 'open_drop_off_senders_user_group_ids':
        case 'open_drop_off_receivers_user_group_ids':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.USER_GROUP}
                    />
                </AsyncComponent>
            );
        case 'product_group_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PRODUCT_GROUP}
                    />
                </AsyncComponent>
            );
        case 'category_id':
        case 'default_product_category_id':
        case 'default_product_root_category_id':
        case 'default_shop_product_root_category_id':
        case 'product_category_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PRODUCT_CATEGORY}
                    />
                </AsyncComponent>
            );
        case 'questionnaire_id':
        case 'consume_questionnaire_id':
        case 'return_questionnaire_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.QUESTIONNAIRE}
                    />
                </AsyncComponent>
            );
        case 'equipment_group_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.EQUIPMENT_GROUP}
                    />
                </AsyncComponent>
            );
        case 'question_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.QUESTION}
                    />
                </AsyncComponent>
            );
        case 'privacy_policy_document_id':
        case 'document_id':
        case 'notification_logo_document_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.DOCUMENT}
                    />
                </AsyncComponent>
            );
        case 'package_id':
        case 'drop_off_package_id':
        case 'pick_up_package_id':
        case 'dependent_package_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PACKAGE}
                    />
                </AsyncComponent>
            );
        case 'transaction_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.TRANSACTION}
                    />
                </AsyncComponent>
            );
        case 'iot_id':
        case 'twin_iot_id':
        case 'default_printer_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.IOT}
                    />
                </AsyncComponent>
            );
        case 'workflow_id':
        case 'transaction_workflow_id':
        case 'colli_workflow_id':
        case 'package_workflow_id':
        case 'deceased_workflow_id':
        case 'drop_off_package_workflow_id':
        case 'pick_up_package_workflow_id':
        case 'drop_off_moved_package_workflow_id':
        case 'pick_up_moved_package_workflow_id':
        case 'courier_pick_up_package_workflow_id':
        case 'destination_pick_up_package_workflow_id':
        case 'source_drop_off_package_workflow_id':
        case 'courier_drop_off_package_workflow_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.WORKFLOW}
                    />
                </AsyncComponent>
            );
        case 'device_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.DEVICE}
                    />
                </AsyncComponent>
            );
        case 'equipment_problem_id':
        case 'problem_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.PROBLEM}
                    />
                </AsyncComponent>
            );
        case 'user_interface_id':
        case 'default_user_interface_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.USER_INTERFACE}
                    />
                </AsyncComponent>
            );
        case 'job_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.JOB}
                    />
                </AsyncComponent>
            );
        case 'value_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.ATTRIBUTE_VALUE}
                    />
                </AsyncComponent>
            );
        case 'report_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.REPORT}
                    />
                </AsyncComponent>
            );
        case 'role_id':
        case 'default_user_account_role_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.ROLE}
                    />
                </AsyncComponent>
            );
        case 'wizard_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.WIZARD}
                    />
                </AsyncComponent>
            );
        case 'basket_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.BASKET}
                    />
                </AsyncComponent>
            );
        case 'label_template_id':
            return (
                <AsyncComponent fallback={fallback}>
                    <ObjectBadge
                        {...props}
                        entityType={EntityType.LABEL_TEMPLATE}
                    />
                </AsyncComponent>
            );
    }
    return <></>;
};
